import { generateUUID } from 'common/utils/utils';

export default function defaultPhoneNumber(isPrimary = false) {
  return {
    id: generateUUID(),
    acceptable_communication_types: {},
    is_primary: isPrimary,
  };
}
